import mediaDataTransformer from "./mediaDataTransformer"
const projectDetailWithMediaDataTransformer = response => {
  const mediaData = mediaDataTransformer(response)
  const possessionData = response?.Possessions
  const finishingData =
    possessionData?.length > 0 && possessionData?.[0]?.finishing != null && possessionData?.[0]?.finishingUnit != null
      ? {
          finishingAmount: possessionData?.[0]?.finishing,
          finishingUnit: possessionData?.[0]?.finishingUnit,
        }
      : null
  return {
    ...mediaData,
    finishingData,
  }
}

export default projectDetailWithMediaDataTransformer
